// extracted by mini-css-extract-plugin
export var notificationHost = "_gc-0";